/* eslint-disable */

window.$ = jQuery;
import tinycolor from 'tinycolor2';
import './jquery.br-scroll-to';
import './jquery.br-validate';
import './archive_search';
import './chart-breakdown';

(function($) {

    if(window.location.hash === '#comp-joz452v8img' ) {
        window.location.replace(`${window.location.origin}/registration/`);
    }

    class BRIntersect {
        constructor( el, options = {} ) {
            this.el = el;

            const defaults = {
                filter: null,
                onIntersect() {},
            };

            this.options = $.extend( {}, defaults, options );

            this.setIntersectingElements();
            this._onIntersect();

            $(window).on('resize', () => {
                this.setIntersectingElements();
                this._onIntersect();
            });

        }

        _onIntersect() {
            this.options.onIntersect( this.el, this.getMostIntersectedElement() );
        }

        getBoundingClientRect() {
            return this.el.getBoundingClientRect();
        }

        setIntersectingElements() {
            let intersectingElements = [ ...document.querySelectorAll( this.options.filter) ].filter( el => {
                const thisRect = this.getBoundingClientRect(),
                      elRect = el.getBoundingClientRect();

                return !(
                    thisRect.top > elRect.bottom ||
                    thisRect.right < elRect.left ||
                    thisRect.bottom < elRect.top ||
                    thisRect.left > elRect.right
                );
            });

            this.intersectingElements = intersectingElements.map( el => {
                const thisRect = this.getBoundingClientRect(),
                    elRect = el.getBoundingClientRect();

                const leastLeft = thisRect.left >= elRect.left ? thisRect.left : elRect.left,
                    leastRight = thisRect.right <= elRect.right ? thisRect.right : elRect.right,
                    leastTop = thisRect.top >= elRect.top ? thisRect.top : elRect.top,
                    leastBottom = thisRect.bottom <= elRect.bottom ? thisRect.bottom : elRect.bottom,
                    overlapWidth = leastRight - leastLeft,
                    overlapHeight = leastBottom - leastTop,
                    overlap = overlapWidth * overlapHeight;

                return {
                    el,
                    overlap
                }
            });
        }

        getMostIntersectedElement() {
            let overlap = 0;
            return this.intersectingElements.filter( el => {
                const isLarger = el.overlap > overlap;
                overlap = el.overlap;
                return isLarger;
            })[0];
        }

    }

    $.fn.brIntersect = function( options = {} ) {
        this.each(function() {
            new BRIntersect( this, options );
        });
    };

    $(document).ready(function() {

        $('a').filter(function() {
            return this.hostname && this.hostname !== location.hostname;
        }).attr('target','_blank');

        $('.form__input--checkbox:not(.form__input--checkbox__icon) input').on('change', e => {
            $(e.target).closest('.form__input--checkbox').toggleClass('form__input--checkbox__checked', () => e.target.checked );
        });

        $('#brand-logo').brIntersect({
            filter: '.swapper',
            onIntersect( el1, el2 ) {
                
                const $el1 = $(el1), $el2 = $(el2),
                    el2bg = tinycolor( window.getComputedStyle(el2.el, null).getPropertyValue("background-color") ),
                    bgColor = el2bg.getAlpha() == 0 ? tinycolor($('body').css('backgroundColor')) : el2bg;

                let brainClassToRemove, brainClassToAdd, textClassToRemove, textClassToAdd;

                if( bgColor.isLight() ) {
                    brainClassToRemove = 'brain-blue-dark';
                    brainClassToAdd = 'brain-blue-lt';
                    textClassToRemove = 'text-white';
                    textClassToAdd = 'text-blue-dark';
                } else {
                    brainClassToRemove = 'brain-blue-dark';
                    brainClassToAdd = 'brain-blue-lt';
                    textClassToRemove = 'text-blue-dark';
                    textClassToAdd = 'text-white';
                }
                $el1.find('.brain').removeClass(brainClassToRemove).addClass(brainClassToAdd);
                $el1.find('.text').removeClass(textClassToRemove).addClass(textClassToAdd);

            }
        });

    });
})(jQuery);